import { PropsWithChildren, useMemo } from 'react'
import Axios from 'axios'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { ClientContext } from '../clientContext/ClientContext'

import { responseFailureInterceptor, responseSuccessInterceptor } from './interceptors/responseInterceptors'
import { requestInterceptor } from './interceptors/requestInterceptors'
import { config } from '@percent/education-hosted-form/config/config'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

export function ClientContextController({ children }: PropsWithChildren) {
  const { i18n } = useTranslation()

  const axios = useMemo(() => {
    const axiosInstance = Axios.create({
      baseURL: `${config.urls.api}`,
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language
      }
    })

    axiosInstance.interceptors.request.use(requestInterceptor)
    axiosInstance.interceptors.response.use(responseSuccessInterceptor, responseFailureInterceptor)

    return axiosInstance
  }, [i18n.language])

  return (
    <ClientContext.Provider value={axios}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ClientContext.Provider>
  )
}
